import { Outlet } from "react-router-dom";
import StaticSocialIcon from "./StaticSocialIcon";
import ProgressScroll from "./ProgressScroll";
import Footer from "./Footer";
import TopBar from "./TopBar";
import Navbar from "./Navbar";

const Layout = () => {
  return (
    <div className="font-SFPro relative bg-[#EDEDED]">
      <TopBar />

      <Navbar />

      {/* Main content area */}
      <Outlet />

      <StaticSocialIcon />

      <ProgressScroll />

      <Footer />
    </div>
  );
};

export default Layout;
